/**
 * Parse the code.
 */
class Parser {

	reservedVariables = [ 'pi', 'e', 'loopcount', 'canvaswidth', 'canvasheight' ];

	/**
	 *
	 */
	constructor( text ) {

		this.text = text;
		this.chunks = [];
		this.functions = [];
		this.tokens = [];
		this.variables = {
			'pi': Math.PI,
			'e': Math.E,
			'repcount': 0,
			'canvaswidth': 512,
			'canvasheight': 512,
		}; // Object to store variables and their values

		// Format text ready for parsing.
		this.text = prepareText( this.text );

		// Convert prepared text into list of chunks.
		this.chunks = lexer( this.text );
		// console.log( 'chunks', this.chunks );

		// Convert chunks into list of commands.
		this.tokenise();

		// Display the tokens.
		// console.table( this.tokens );
		// console.log( 'functions', this.functions );

	}


	/**
	 * Get the next chunk.
	 *
	 * @return {string}
	 */
	nextChunk() {

		// Get the next chunk from the list.
		let chunk = this.chunks.shift();
		// console.log( 'nextChunk', chunk );

		// Everything else.
		switch ( chunk ) {

			case 'random':
			case 'rand':
				return this.parseRandom();

			case 'sum':
			case 'add':
			case 'difference':
			case 'minus':
			case 'multiply':
			case 'times':
			case 'divide':
			case 'over':
			case 'power':
				return this.parseParams( chunk, 2 );

			default:
				return chunk;

		}

	}


	/**
	 * Get next parameters.
	 * This checks for close loops, and stops them from being removed from the list of chunks.
	 *
	 * @return {any}
	 */
	nextParam() {

		let testChunk = this.chunks[ 0 ];

		if ( '}' === testChunk ) {
			return false;
		}

		return this.nextChunk();

	}


	/**
	 * Generate the chunk and it's properties.
	 *
	 * @return {Token}
	 */
	tokenFromChunk( chunk ) {

		// console.log( 'token', chunk );

		switch ( chunk ) {

			case 'repeat':

				return this.parseRepeat();

			case 'function':

				let newFunction = this.parseFunction();
				this.functions[ newFunction.name ] = newFunction.token;

				return;

		}

		let newToken;

		// Generate a token from custom commands.
		newToken = this.commandListToken( commandList, chunk );
		if ( newToken ) { return newToken; }

		// Generate a token from built in commands.
		newToken = this.commandListToken( keywordList, chunk );
		if ( newToken ) { return newToken; }

		return new Token( chunk );

	}


	/**
	 * Generate tokens based upon the specified list of commands.
	 *
	 * @param {array} list The list of commands.
	 * @param {string} chunk The command to search for.
	 * @return {token}
	 */
	commandListToken( list, chunk ) {

		if ( !list ) {
			return false;
		}

		if ( !list[ chunk ] ) {
			return false;
		}

		const command = list[ chunk ];

		if ( command.length > 1 ) {
			switch ( command[ 1 ] ) {
				case 2:
					return new Token( command[ 0 ], [ this.nextParam(), this.nextParam() ] );

				case 3:
					return new Token( command[ 0 ], [ this.nextParam(), this.nextParam(), this.nextParam() ] );

				default:
					return new Token( command[ 0 ], this.nextParam() );

			}
		}

		return new Token( command[ 0 ] );

	}


	/**
	 * Grab nested commands for the repeat command.
	 *
	 * This may need to be simplified so that it's more generic for other
	 * nested properties.
	 *
	 * @return {Token}
	 */
	parseRepeat() {

		const token = new Token( 'repeat' );

		let next = this.nextChunk();

		if ( this.nextChunk() !== '{' ) {
			console.error( 'Error following repeat, expected nn {, got', next );
			return;
		}

		// Don't convert to an int since this could include random numbers and maybe other modifiers.
		token.arg = next;

		while ( ( next = this.nextChunk() ) !== '}' ) {
			token.addCommandToken( this.tokenFromChunk( next ) );
		}

		return token;

	}


	/**
	 * Generate a function from a list of commands.
	 *
	 * @return object
	 */
	parseFunction() {

		const token = new Token( 'function' );

		// Add brackets at the end so that the key matches the function name.
		let name = this.nextChunk() + '()';

		// Check there are commands to run.
		if ( this.nextChunk() !== '{' ) {
			console.error( 'Error creating function, expected {, got', name );
			return;
		}

		// Get the list of commands.
		let next = '';
		while ( ( next = this.nextChunk() ) !== '}' ) {
			token.addCommandToken( this.tokenFromChunk( next ) );
		}

		return { name, token };

	}


	/**
	 * Generate a list of parameters for a command.
	 *
	 * @param {string} arg The command to generate parameters for.
	 * @param {int} count The number of parameters to grab.
	 * @return {string}
	 */
	parseParams( arg = '', count = 2 ) {

		let args = [ arg ];

		// Loop for count times.
		for ( let i = 0; i < count; i++ ) {
			args.push( this.nextChunk() );
		}

		return args.join( ' ' );

	}


	/**
	 * Generate a Random token.
	 *
	 * @return {object}
	 */
	parseRandom() {

		let args = [ 'random' ];

		/**
		 * We look at the chunk data directly.
		 *
		 * When we call nextChunk it removes the item from the array. We don't
		 * want to do this if the next chunk is a token/ command. Accessing the
		 * array directly stops this from happening. We then use nextChunk if
		 * the result is a number.
		 *
		 * We store these first so that we know the values and their positions before we call
		 */
		let next1 = this.chunks[ 0 ];
		let next2 = this.chunks[ 1 ];

		if ( isNumber( next1 ) ) {
			args.push( this.nextChunk() );
		}

		if ( isNumber( next2 ) ) {
			args.push( this.nextChunk() );
		}

		return args.join( ' ' );

	}


	/**
	 * Set the value of a variable.
	 *
	 * @param {array} properties The variable and it's value.
	 * @return {void}
	 */
	setVariable( properties ) {

		const name = properties[ 0 ].replace( '$', '' );

		if ( this.reservedVariables.includes( name ) ) {
			console.error( 'Cannot set reserved variable', name );
			return;
		}

		const value = this.evalMath( properties[ 1 ] );

		this.variables[ name ] = value;
		// console.log( 'setVariable', this.variables );

	}


	/**
	 * Set the value of a reserved variable.
	 * This is used for pi, e, repcount etc.
	 *
	 * @param {string} name The name of the variable.
	 * @param {number} value The value of the variable.
	 * @return {void}
	 */
	setReservedVariable( name, value ) {

		this.variables[ name ] = value;

	}


	/**
	 * Get the value of a variable.
	 *
	 * @param {string} variable The variable to get.
	 * @return {number}
	 */
	getVariable( variable ) {

		// console.log( 'getvariable', variable, this.variables[ variable ] );

		// Return any numbers mistakenly passed in.
		if ( isNumber( variable ) ) {
			return Number( variable );
		}

		// Just in case.
		variable = variable.replace( '$', '' );

		if ( !this.variables[ variable ] ) {
			return 0;
		}

		// console.log( 'getVariable', this.variables[ variable ] );
		return Number( this.variables[ variable ] );

	}


	/**
	 * Evaluate the math.
	 *
	 * @param {string} arg The math to evaluate.
	 * @return {number}
	 */
	evalMath( arg ) {

		if ( isNumber( arg ) ) {
			return Number( arg );
		}

		// console.log( 'evalMath', arg );

		let bits = arg.split( ' ' );

		switch ( bits[ 0 ] ) {

			case 'sum':
			case 'add':
				return this.getVariable( bits[ 1 ] ) + this.getVariable( bits[ 2 ] );

			case 'difference':
			case 'minus':
				return this.getVariable( bits[ 1 ] ) - this.getVariable( bits[ 2 ] );

			case 'multiply':
			case 'times':
				return this.getVariable( bits[ 1 ] ) * this.getVariable( bits[ 2 ] );

			case 'divide':
			case 'over':
				return this.getVariable( bits[ 1 ] ) / this.getVariable( bits[ 2 ] );

			case 'power':
			case 'pow':
				return this.getVariable( bits[ 1 ] ) ** this.getVariable( bits[ 2 ] );

		}

		return arg;

	}


	/**
	 * Generate the Tokens.
	 *
	 * @return {void}
	 */
	tokenise() {

		let chunk;

		this.tokens = [];

		while ( ( chunk = this.nextChunk() ) !== undefined ) {
			const newToken = this.tokenFromChunk( chunk );
			if ( newToken ) {
				this.tokens.push( newToken );
			}
		}

	}

}
